<template>
  <div class="container">
    <div class="d-flex flex-column text-center">
      <p v-if="seconds > 0">
        Vous allez être redirigé(e) automatiquement
        <br>
        <span class="fw-bold">
          dans {{ seconds }} seconde{{ seconds > 1 ? 's' : '' }}
        </span>
        <br>
        vers votre signature de document.
      </p>
      <div v-else>
        <div class="mt-3">
          Redirection en cours
          <span class="loader__dot">.</span>
          <span class="loader__dot">.</span>
          <span class="loader__dot">.</span>
        </div>
        <div
          class="spinner-border text-primary mx-auto my-3"
          style="width: 2rem;
                height: 2rem;
                border-width: thin;"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash-es';

export default {
  name: 'CustomisationTimer',
  props: {
    seconds: {
      type: Number,
      default: 15,
    },
  },
  data() {
    return {
      path: 'https://app.assurup.com/login',
      debouncer: ({ cancel: () => {} }),
    };
  },
  computed: {
    ready() { return this.seconds <= 0; },
    progress() { return this.$store.getters['routing/progress']; },
  },
  watch: {
    seconds: {
      handler(value) {
        if (value < -1) {
          this.redirectToDashboard();
        }
      },
    },
  },
  mounted() {
    if (this.seconds < 0) {
      this.redirectToDashboard();
    }
  },
  methods: {
    redirectToDashboard() {
      this.debouncer.cancel();
      const debouncerFunction = () => {
        window.location.assign('/client');
      };
      this.debouncer = debounce(debouncerFunction, 1500);
      this.debouncer();
    },
  },
};
</script>

<style scoped>
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;
}
</style>
